import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PageComponent } from '../../components/page/page.component';
import { ActivatedRoute } from '@angular/router';
import { RouteUtil } from 'src/app/general/util/route-util';
import { SessionService } from '../../services/session.service';
import { AuthenticationStatus } from '../../util/util';
import { LocationHeaderComponent } from '../../components/location-header/location-header.component';
import { OrdersComponent } from '../../components/orders/orders.component';
import { OrdersModel } from '../../components/orders/orders-model';
import { LocationPaidOrdersModel } from '../../components/orders/location-paid-orders-model';
import { BackendService } from '../../services/backend.service';
import { Util } from 'src/app/general/util/util';
import { NavigationService } from '../../services/navigation.service';
import { ActionComponent } from 'src/app/general/components/action/action.component';

@Component({
  selector: 'app-location-orders-page',
  standalone: true,
  imports: [
    CommonModule,
    PageComponent,
    TranslateModule,
    LocationHeaderComponent,
    OrdersComponent,
    ActionComponent,
  ],
  templateUrl: './location-orders-page.component.html',
  styleUrls: ['./location-orders-page.component.css']
})
export class LocationOrdersPageComponent implements OnInit {
  locationId: string;
  locationPaidOrdersModel: OrdersModel;

  constructor(
      private sessionService: SessionService,
      private activatedRoute: ActivatedRoute,
      private backendService: BackendService,
      private navigationService: NavigationService) {
    this.locationId = '';
    this.locationPaidOrdersModel = new LocationPaidOrdersModel(this.locationId, this.backendService);
  }

  ngOnInit(): void {
    if (this.sessionService.enforceAuthentication()
        == AuthenticationStatus.USER_NOT_AUTHENTICATED_AND_REDIRECTED_TO_SIGNIN_PAGE) {
      return;
    }

    const pathParams = RouteUtil.getPathParams(this.activatedRoute);
    this.locationId = Util.safeString(pathParams.get('locationId'));
    this.locationPaidOrdersModel = new LocationPaidOrdersModel(this.locationId, this.backendService);
  }

  public goToLocationPage(): void {
    this.navigationService.goToLocationPage(this.locationId)
  }
}
